// extracted by mini-css-extract-plugin
module.exports = {"content":"PushBlockContainer_content__obAcr"};